import { i18n, inject, observer, pr, React, RouteComponentProps, ui } from "aaa";
import { MessageScreen } from "components/common/MessageScreen";
import { ExternalInterfaceStore } from "stores/ExternalInterfaceStore";
import { safeWindowOpen } from "util/helpers";

interface IProps {
    externalInterfaceStore: ExternalInterfaceStore;
}

// NOT USED: we directly return after signing
@inject("externalInterfaceStore")
@observer
export class TeamcardLinkageSuccess extends React.Component<IProps & i18n.InjectedIntlProps & RouteComponentProps<{}>, {}> {
    render() {
        return (
            <MessageScreen
                icon={pr.IconMessageOk}
                // useWebVersion
                // variant="success"
                title={ui.__("teamcardLinkage.success.message")}
                message={ui.__("teamcardLinkage.success.message.subtext")}
                buttonLabelId="teamcardLinkage.button.finish"
                onDismiss={() => {
                    safeWindowOpen("georgeapp://at/deeplink?path=overview&dataReload=true");
                    // this.props.externalInterfaceStore.raiseExitSuccess();
                }}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/teamcardLinkage/TeamcardLinkageSuccess.tsx